import GameTags, { peopleCount } from "../../../shared/components/other/GameTags/GameTags";
import { FormatDate } from "../../../shared/shared";


interface GameCardProps {
    openState: string;
    peopleCount: peopleCount;
    name: string;
    dateTime: string;
    place: string;
    imgSrc: any;
    tags?: Array<string>;
    slug?: "86916-straikbol-alushta-2004";
}

//дату передвавать в Iso бех хвостовой части 

//peopleCount ссделать самостоятельное округление
//Преобразование времени из ISO формате
//Поддержка any 
export default function GameCard (props: GameCardProps) {
    const { openState: openState, peopleCount, name, dateTime, place, imgSrc, tags = [], slug} = props;

    const parsedTags = tags

    const date = FormatDate(dateTime);

    const no_photo = '/no_photo.svg' 

    let preview;

    if (!imgSrc) {
        preview = no_photo
    } else if (typeof(imgSrc) == typeof(""))
        preview = imgSrc;
    else {
        const imgObj =  imgSrc.filter((obj:any)=>{return obj.is_preview})[0]?.image_link || no_photo
        preview = imgObj
    }

    return (
        <a className="gameCard" href={'/gameInfo/'+ slug}>
            <div className="gameCard-container">
                <div className="gameCard-preview-container">
                    <img src={preview} alt="" className="gameCard-preview" />
                </div>
                <GameTags openState={openState} peopleCount={peopleCount} additionalTags={parsedTags} tagClass='gameCard_tag'></GameTags>
                <div className="gameCard-info">
                    <h3 className="gameCard-name">{name}</h3>
                    <p className="gameCard-info-text gameCard-info-date">{date}</p>
                    <p className="gameCard-info-text gameCard-info-place">{place}</p>
                </div>
            </div>
        </a>
    )
}
